import React, { Component } from "react";
import { Grid, Row, Col } from "react-app-flexbox-grid";
import Table from "../Table/Table";
import { network } from "../Network";
import { getLedgers, getTransactions, getStats } from "../../fetch";
import moment from "moment";
import history from "../history";
import "./Explorer.css";
import { isNftCheck } from "../../nft";
import { formatBalance } from "../balances";

const NetworkStatus = ({ sequence, avg, time, ago }) => (
  <div className="explorer-block">
    {sequence && avg && time && ago ? (
      <React.Fragment>
        <h2 className="explorer-title">Network Status</h2>
        <div className="explorer-net-icon">
          <img className="image-icon" src="/assets/images/network.png" alt="" />
        </div>
        <p className="explorer-net-ok">
          {sequence && avg && time && ago
            ? "Up and running!"
            : "Failed or partially failed!"}
        </p>
        <p className="explorer-net-last-id">
          Last ledger:{" "}
          {sequence !== undefined ? `# ${sequence}` : "Not available"}
        </p>
        <p className="explorer-net-text">
          Average ledger close time in the last 200 ledgers:{" "}
          {avg !== undefined ? `${avg} sec` : "Not available"}
        </p>
        <p className="explorer-net-text">
          Last ledger closed at:{" "}
          {time !== undefined && ago !== undefined
            ? `${time} in ${ago}.`
            : "Not available"}
        </p>
      </React.Fragment>
    ) : (
      <div className="explorer-loader">
        <div className="explorer-loader-image"></div>
      </div>
    )}
  </div>
);

class Explorer extends Component {
  render() {
    return (
      <Grid fluid className="explorer">
        <Row>
          <Col xs={12} className="over">
            <NetworkStatus {...this.state.monitor} />
          </Col>
          <Col xs={12} className="over">
            <div className="explorer-block">
              <h2 className="explorer-title">Transactions</h2>
              <Table data={this.state.ops} />
            </div>
          </Col>
          <Col xs={12} className="over">
            <div className="explorer-block">
              <h2 className="explorer-title">Recent Ledgers</h2>
              <Table data={this.state.ledgers} />
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }

  formatDuration(value) {
    var result = 0;
    var sec = Math.round(value / 1000);
    if (sec < 60) {
      result = sec + "s";
    } else {
      var min = Math.round(sec / 60);
      if (min < 60) {
        result = min + "m";
      } else {
        var hours = Math.round(min / 60);
        if (hours < 60) {
          result = hours + "h";
        } else {
          result = Math.round(hours / 24) + "d";
        }
      }
    }
    return result;
  }

  formatType(string) {
    return string
      .split("_")
      .map((s) => {
        return s.charAt(0).toUpperCase() + s.slice(1);
      })
      .join(" ");
  }

  async formatOperation(o) {
    const isNft = await isNftCheck(o.asset_issuer, o.asset_code, network);
    const isSourceNft = await isNftCheck(
      o.source_asset_issuer,
      o.source_asset_code,
      network
    );
    const isSellingNft = await isNftCheck(
      o.selling_asset_issuer,
      o.selling_asset_code,
      network
    );
    const isBuyingNft = await isNftCheck(
      o.buying_asset_issuer,
      o.buying_asset_code,
      network
    );
    var result = [];
    if (o.type_i === 0) {
      result.push(
        <p key={"op_create" + o.id} className="inject">
          {formatBalance(o.starting_balance)} XDB >>{" "}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.account);
            }}
          >
            {o.account.substring(0, 4)}
          </button>
        </p>
      );
    }
    if (o.type_i === 1) {
      result.push(
        <p key={"op_pay" + o.id} className="inject">
          {formatBalance(o.amount, isNft)}{" "}
          {o.asset_type === "native" ? "XDB" : o.asset_code}{" "}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.from);
            }}
          >
            {o.from.substring(0, 4)}
          </button>{" "}
          >>{" "}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.to);
            }}
          >
            {o.to.substring(0, 4)}
          </button>
        </p>
      );
    }
    if (o.type_i === 2) {
      result.push(
        <p key={"op_receive" + o.id} className="inject">
          {`Received ${formatBalance(o.amount, isNft)} ${
            o.asset_type === "native" ? "XDB" : o.asset_code
          } by `}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.to);
            }}
          >
            {o.to && o.to.substring(0, 4)}
          </button>
          {` << Sent ${formatBalance(o.source_amount, isSourceNft)} ${
            o.source_asset_type === "native" ? "XDB" : o.source_asset_code
          } from `}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.source_account);
            }}
          >
            {o.source_account && o.source_account.substring(0, 4)}
          </button>
        </p>
      );
    }
    if (o.type_i === 13) {
      result.push(
        <p key={"op_receive" + o.id} className="inject">
          {`Sent ${formatBalance(o.source_amount, isSourceNft)} ${
            o.source_asset_type === "native" ? "XDB" : o.source_asset_code
          } from `}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.source_account);
            }}
          >
            {o.source_account && o.source_account.substring(0, 4)}
          </button>
          {` >> Received ${formatBalance(o.amount, isNft)} ${
            o.asset_type === "native" ? "XDB" : o.asset_code
          } by `}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.to);
            }}
          >
            {o.to && o.to.substring(0, 4)}
          </button>
        </p>
      );
    }
    if (o.type_i === 4) {
      result.push(
        <p key={"op_passive_offer" + o.id} className="inject">
          {`Selling ${formatBalance(o.amount, isSellingNft)} ${
            o.selling_asset_type === "native" ? "XDB" : o.selling_asset_code
          } `}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.selling_asset_issuer);
            }}
          >
            {o.selling_asset_issuer && o.selling_asset_issuer.substring(0, 4)}
          </button>
          {` for ${formatBalance(o.price * o.amount, isBuyingNft)} ${
            o.buying_asset_type === "native" ? "XDB" : o.buying_asset_code
          } `}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.buying_asset_issuer);
            }}
          >
            {o.buying_asset_issuer && o.buying_asset_issuer.substring(0, 4)}
          </button>
        </p>
      );
    }
    if (o.type_i === 3) {
      result.push(
        <p key={"op_sell" + o.id} className="inject">
          {`Sell ${formatBalance(o.amount, isSellingNft)} ${
            o.selling_asset_type === "native" ? "XDB" : o.selling_asset_code
          } `}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.selling_asset_issuer);
            }}
          >
            {o.selling_asset_issuer && o.selling_asset_issuer.substring(0, 4)}
          </button>
          {` for ${formatBalance(o.price * o.amount, isBuyingNft)} ${
            o.buying_asset_type === "native" ? "XDB" : o.buying_asset_code
          } `}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.buying_asset_issuer);
            }}
          >
            {o.buying_asset_issuer && o.buying_asset_issuer.substring(0, 4)}
          </button>
        </p>
      );
    }
    if (o.type_i === 12) {
      result.push(
        <p key={"op_buy" + o.id} className="inject">
          {`Buy ${formatBalance(o.amount, isBuyingNft)} ${
            o.buying_asset_type === "native" ? "XDB" : o.buying_asset_code
          } `}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.buying_asset_issuer);
            }}
          >
            {o.buying_asset_issuer && o.buying_asset_issuer.substring(0, 4)}
          </button>
          {` for ${formatBalance(o.price * o.amount, isSellingNft)} ${
            o.selling_asset_type === "native" ? "XDB" : o.selling_asset_code
          } `}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.selling_asset_issuer);
            }}
          >
            {o.selling_asset_issuer && o.selling_asset_issuer.substring(0, 4)}
          </button>
        </p>
      );
    }
    if (o.type_i === 5) {
      result.push(
        <p key={"op_option" + o.id} className="inject">
          By{" "}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.source_account);
            }}
          >
            {o.source_account.substring(0, 4)}
          </button>
        </p>
      );
    }
    if (o.type_i === 6 || o.type_i === 7) {
      result.push(
        <p key={"op_trust" + o.id} className="inject">
          Trustee:{" "}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.trustee);
            }}
          >
            {o.trustee.substring(0, 4)}
          </button>
          , trustor:{" "}
          <button
            type="button"
            className="inject-active"
            onClick={() => {
              history.push("/address/" + o.trustor);
            }}
          >
            {o.trustor.substring(0, 4)}
          </button>
        </p>
      );
    }
    return result;
  }

  processLedgers(data, state) {
    if (data !== null && data !== undefined) {
      const { times = [], historyPayments = [] } = data.records.reduce(
        (acc, item) => ({
          times: acc.times.concat(item.closed_at),
          historyPayments: [
            {
              name:
                moment(item.closed_at).format("YYYY-MM-DD HH:mm:ss") +
                " " +
                item.sequence,
              Ops: item.operation_count,
              Txs: item.successful_transaction_count,
              Sequence:
                item.operation_count > 0 ||
                item.successful_transaction_count > 0
                  ? 0
                  : 1,
            },
          ].concat(acc.historyPayments),
        }),
        { times: [], historyPayments: [] }
      );
      const timediff = times.reduce(
        (acc, time, currentIndex, arr) =>
          currentIndex < arr.length - 1
            ? acc + moment(time).diff(moment(arr[currentIndex + 1]))
            : acc,
        0
      );
      const monitor = {
        ...state.monitor,
        sequence: data.records.slice(0, 1)[0].sequence,
        time: moment(data.records.slice(0, 1)[0].closed_at).format(
          "ddd MMM DD YYYY HH:mm:ss ZZ"
        ),
        avg: Math.round(timediff / (times.length - 1) / 10) / 100,
        ago: this.formatDuration(
          moment(data.records.slice(0, 1)[0].closed_at).diff(
            moment(data.records.slice(1, 2)[0].closed_at)
          )
        ),
      };
      const items = data.records.slice(0, 5).map((item) => [
        {
          text: item.sequence,
          callback: () => {
            history.push("/sequence/" + item.sequence);
          },
        },
        { text: this.formatDuration(moment().diff(moment(item.closed_at))) },
        { text: item.successful_transaction_count },
        { text: item.operation_count },
      ]);

      return {
        ...state,
        historyPayments,
        monitor,
        ledgers: {
          ...state.ledgers,
          items,
        },
      };
    }

    return {
      ...state,
      monitor: {
        sequence: undefined,
        time: undefined,
        avg: undefined,
        ago: undefined,
      },
    };
  }

  processOperations(data) {
    const getOperations = async () => {
      const items = [];
      for (const operation of data.records) {
        items.push([
          {
            text: operation.hash.substring(0, 4),
            callback: () => {
              history.push("/transaction/" + operation.hash);
            },
          },
          { text: this.formatType(operation.type) },
          { text: await this.formatOperation(operation) },
          {
            text: this.formatDuration(
              moment().diff(moment(operation.created_at))
            ),
          },
        ]);
      }

      this.setState((prevState) => ({
        ops: {
          ...prevState.ops,
          items,
        },
      }));
    };
    if (data != null) {
      getOperations();
    }
  }

  processHistory(data, state) {
    if (data !== null && data !== undefined) {
      var network = [],
        min,
        max,
        cache;
      data.forEach((d) => {
        var test = moment(d.date);
        if (min === undefined || test.diff(min) < 0) {
          min = moment(test);
          cache = d;
        }
        if (max === undefined || test.diff(max) > 0) {
          max = moment(test);
        }
      });

      for (
        let m = moment(min);
        m.diff(max) <= 0 && cache != null;
        m.add(1, "days")
      ) {
        var entry = data.filter((d) => {
          return moment(d.date).diff(m) === 0;
        })[0];
        var previousEntry = data.filter((d) => {
          const mCopy = m.clone().subtract(1, "days");
          return moment(d.date).diff(mCopy) === 0;
        })[0];
        if (entry !== undefined) {
          network.push({
            date: entry.date,
            name: moment(m).format("MM/DD/YY"),
            Accounts: entry.accounts,
            Trades: entry.trades,
            Transactions: entry.transactions,
            newAccounts: previousEntry !== undefined ? entry.accounts - previousEntry.accounts : 0,
          });
          cache = entry;
        } else {
          network.push({
            date: moment(m).format("YYYY-MM-DD"),
            name: moment(m).format("MM/DD/YY"),
            Accounts: cache.accounts,
            Trades: 0,
            Transactions: 0,
            newAccounts: 0,
          });
        }
      }

      state.network = network;
    }
    return state;
  }

  load() {
    getLedgers((data = {}) => {
      this.setState(this.processLedgers(data.data, this.state));
    }, network);
    getTransactions((data = {}) => {
      this.processOperations(data.data, this.state);
    }, network);
    getStats((data = {}) => {
      let newData = null;

      if (data) {
        newData = data.data;
      }
      this.setState(this.processHistory(newData, this.state));
    }, network);
  }

  componentDidMount() {
    if (this.state.preloaded === false) {
      this.load();
    } else {
      getTransactions((data) => {
        this.processOperations(data.data);
      }, network);
    }
    this.interval = setInterval(() => {
      this.load();
    }, 15000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  constructor(props) {
    super(props);
    this.interval = null;
    let state = {
      preloaded: false,
      monitor: {
        sequence: 0,
        avg: 0,
        time: moment().format("ddd MMM DD YYYY HH:mm:ss ZZ"),
        ago: 0,
      },
      network: [],
      historyPayments: [],
      ops: {
        headers: [
          { text: "ID", width: "15%" },
          { text: "Operation", width: "25%" },
          { text: "Details", width: "45%" },
          { text: "Age", width: "15%", align: "center" },
        ],
        items: [],
      },
      ledgers: {
        headers: [
          { text: "Sequence", width: "40%", align: "center" },
          { text: "Age", width: "20%", align: "center" },
          { text: "TXs", width: "20%", align: "center" },
          { text: "Ops", width: "20%", align: "center" },
        ],
        items: [],
      },
    };
    let data = this.props.params.data;
    if (data == null) {
      if (
        typeof window !== "undefined" &&
        window != null &&
        window.__INITIAL_STATE__ != null &&
        window.__INITIAL_STATE__.data != null
      ) {
        data = window.__INITIAL_STATE__.data;
        window.__INITIAL_STATE__.data = null;
      }
    }
    if (data !== null && data !== undefined) {
      state.preloaded = true;
      state = this.processLedgers(data.ledgers, state);
      state = this.processHistory(data.history, state);
    }

    this.state = state;
  }
}
export default Explorer;



// WEBPACK FOOTER //
// ./src/components/Explorer/Explorer.js